import React from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import { buildAuthUrl } from '../../utils/utils';
import { getClientId, getIDPURL, getVisionLogoutAPI } from '../../utils/envVals';
import './style.css';
import NavListItem from './NavListItem';


const LogoutButton: React.FC = () => {
    const idpURL = getIDPURL();
    const clientId = getClientId();
    const handleLogout = () => {
        const origin = window.location.origin
        fetch(getVisionLogoutAPI(), { method: 'POST' }).then(() => {
            window.location.href = buildAuthUrl(`${idpURL}/ssologout`, {
                clientId: clientId,
                postLogoutRedirect: encodeURI(origin)
            })
            localStorage.clear();
            sessionStorage.clear();
        })
    };
    return <NavListItem
        label="Sign out"
        onClick={handleLogout}
        iconElement={<LogoutIcon />} />
};

export default LogoutButton;